var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { attrs: { height: "10px" } }, [
        _c(
          "div",
          _vm._l(_vm.mapPosData, function(pos, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "posDiv",
                on: {
                  click: function($event) {
                    return _vm.handleSetPoint(pos)
                  }
                }
              },
              [
                _c("img", {
                  key: index,
                  staticStyle: {
                    position: "relative",
                    left: "0px",
                    top: "0px"
                  },
                  attrs: {
                    src:
                      "https://cdn-tech.cozzia.com.cn/dev/robot/news/20200320140958_mnrr.svg",
                    width: "25px"
                  },
                  on: {
                    load: function($event) {
                      return _vm.imageLoad($event, pos, index)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(pos.name))])
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("el-main", [
        _c(
          "div",
          { staticStyle: { position: "relative", top: "0px", left: "0px" } },
          [_c("img", { attrs: { src: _vm.mapSrc, height: "372.5px" } })]
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            modal: false,
            title: _vm.title,
            width: "600px",
            visible: _vm.nextPostShow,
            "before-close": _vm.closeNextPosShow,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.nextPostShow = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "setPosOrder",
              attrs: {
                model: _vm.addData,
                rules: _vm.rules,
                "label-width": "160px",
                size: "small"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "巡点顺序：", prop: "posId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.addData.posId,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "posId", $$v)
                        },
                        expression: "addData.posId"
                      }
                    },
                    _vm._l(_vm.hasPosData, function(pos) {
                      return _c("el-option", {
                        key: pos,
                        attrs: { label: pos, value: pos }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: " " } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSetPosOrder }
                    },
                    [_vm._v("确认")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }